import selectNodesWithRelativePosition from './selectNodesWithRelativePosition';
import getLandmarkNodes from './getLandmarkNodes';
import getRole from './getRole';

export function focusNextRegion() {
    const focusable = selectNodesWithRelativePosition(
        getLandmarkNodes(),
        'after',
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (12,9): Argument of type 'Element | null' is not assignable to parameter of type 'Element'.
        // @ts-expect-error
        document.activeElement
    ).filter(getRole)[0];
    return focusable && focusable.focus();
}
export function focusPreviousRegion() {
    const focusable = selectNodesWithRelativePosition(
        getLandmarkNodes(),
        'before',
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (23,9): Argument of type 'Element | null' is not assignable to parameter of type 'Element'.
        // @ts-expect-error
        document.activeElement
    )
        .filter(getRole)
        .reverse()[0];
    return focusable && focusable.focus();
}
